var _circle, _rect, _rect2, _path, _rect3, _rect4, _rect5, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInTransit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 14,
    cy: 46,
    r: 14,
    fill: "#94D8ED"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.4,
    y: 43.8,
    width: 37.2,
    height: 6,
    rx: 1,
    stroke: "#25557B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.801,
    y: 39.6,
    width: 32.4,
    height: 4.2,
    rx: 1,
    stroke: "#25557B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 18.203a1 1 0 01.68-.947l15.2-5.147a1 1 0 01.642 0l15.2 5.147a1 1 0 01.679.947V20.6a1 1 0 01-1 1H14.8a1 1 0 01-1-1v-2.397z",
    stroke: "#25557B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.4,
    y: 21.6,
    width: 3.6,
    height: 18,
    rx: 1,
    stroke: "#25557B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28.2,
    y: 21.6,
    width: 3.6,
    height: 18,
    rx: 1,
    stroke: "#25557B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 21.6,
    width: 3.6,
    height: 18,
    rx: 1,
    stroke: "#25557B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53 42c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10z",
    fill: "#95D8ED",
    stroke: "#24547A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.646 42.57h6.093l-1.662 1.692a.68.68 0 00-.185.47.61.61 0 00.185.47c.277.282.692.282.923 0l2.815-2.82a.61.61 0 00.185-.469.724.724 0 00-.185-.47L45 38.624c-.277-.281-.692-.281-.923 0-.277.282-.277.705 0 .94l1.662 1.691h-6.093c-.37 0-.646.33-.646.705v.047c0 .282.277.564.646.564z",
    fill: "#24547A",
    stroke: "#24547A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInTransit);
export default __webpack_public_path__ + "static/media/in-transit.dd003521d5878341d511e04f310edd59.svg";
export { ForwardRef as ReactComponent };